<!-- <div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>   -->

<div *ngIf="selectedFilters != null && selectedFilters.length > 0">
    <mat-form-field class="filter-chip-list" appearance="fill">
        <mat-label>Filter</mat-label>
        <mat-chip-list #chipList aria-label="Filter-Auswahl">
            <mat-chip 
                *ngFor="let selectedFilter of selectedFilters"
                color="warn"
                selected
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(selectedFilter)">
                {{selectedFilter.text}}
                <mat-icon matChipRemove *ngIf="removable" matTooltip="Filter entfernen">cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>
    </mat-form-field>
</div>